import { z } from 'zod';

import { changeProposalResponseEventSchema } from './change-proposal';
import { clarifyOptionsResponseEventSchema } from './clarify-options';
import { helloHitlResponseEventSchema } from './hello-hitl';
import { reasoningResponseEventSchema } from './reasoning';

export * from './change-proposal';
export * from './clarify-options';
export * from './hello-hitl';
export * from './reasoning';

export const structuredResponseEventSchema = z.discriminatedUnion('toolId', [
    clarifyOptionsResponseEventSchema,
    changeProposalResponseEventSchema,
    reasoningResponseEventSchema,
    helloHitlResponseEventSchema,
]);

export type StructuredResponseEvent = z.infer<typeof structuredResponseEventSchema>;

export type StructuredToolId = StructuredResponseEvent['toolId'];
